export default () => {
    return {
        users: [],
        users_summary: {},
        theme: {
            colors: {
                primary: '#ABC03F',
                success: '#28C76F',
                danger: '#EA5455',
                warning: '#FF9F43',
                dark: '#616D70'
            },
            footerType: 'static', // options[String]  : static(default) / sticky / hidden
            hideScrollToTop: false, // options[Boolean] : true, false(default)
            mainLayoutType: 'horizontal', // options[String]  : vertical(default) / horizontal
            navbarColor: '#fff', // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
            navbarType: 'floating', // options[String]  : floating(default) / static / sticky / hidden
            routerTransition: 'slide-fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
            rtl: false, // options[Boolean] : true, false(default)
            sidebarCollapsed: false, // options[Boolean] : true, false(default)
            theme: 'auto' // options[String]  : "light"(default), "dark", "semi-dark"
        }
    }
}
